import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Skeleton } from '@lognai/synapse-design-system-v2';

/**
 * ProtectedRoute Component
 *
 * Protects routes that require authentication.
 * Redirects to login if not authenticated.
 */
export default function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    // The whole-screen wait before anything is known. It was a bare pulsing
    // circle with no text of any kind, so a screen reader had nothing to
    // announce — the app simply went silent until the session resolved
    // (QA ledger AUTH gap found alongside NAV-002).
    return (
      <div
        className="flex h-screen items-center justify-center"
        role="status"
        aria-live="polite"
      >
        <Skeleton className="h-12 w-12 rounded-full" aria-hidden />
        <span className="sr-only">Loading your session…</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
